import { toNumber } from 'lodash';
import type { FC } from 'react';
import { useContext, useRef } from 'react';
import React from 'react';

import BoxModal from '../../../components/ui/BoxModal';
import InputNumber from '../../../components/ui/InputNumber';
import ConfigRentContext from '../../../service/context/config-rent';
import useAppStoreRent from '../../../service/store/appRent';
import useOrderStoreRent from '../../../service/store/orderRent';
import type { IRentalProduct } from '../../../types';
import { scrollToRef } from '../../../utils/scroll';
import FilterRent from '../components/FilterRent';
import ProductList from '../components/ProductList';

const POPUP_PRODUCT_MACHINE = 'Pressmaschine im Koffer mit Akku und Ladegerät';
const POPUP_PRODUCT_ZUGBACKE = 'Zugbacke / Zwischenbacke';

const StepProductSelect: FC = () => {
  const {
    showRentInfo,
    setShowRentInfo,
    setStep
  } = useAppStoreRent(state => state);
  const addProduct = useOrderStoreRent(state => state.addProduct);
  const changeProductQuantity = useOrderStoreRent(state => state.changeProductQuantity);
  const removeProduct = useOrderStoreRent(state => state.removeProduct);
  const products = useOrderStoreRent(state => state.order.products);
  const appContext = useContext(ConfigRentContext);
  const rentInfoRef = useRef<null | HTMLDivElement>(null);

  const machineProduct = appContext?.products?.find(p => p.name === POPUP_PRODUCT_MACHINE);
  const zugbackeProduct = appContext?.products?.find(p => p.name === POPUP_PRODUCT_ZUGBACKE);

  const machineQty = machineProduct ? products[machineProduct.id]?.quantity ?? 0 : 0;
  const zugbackeQty = zugbackeProduct ? products[zugbackeProduct.id]?.quantity ?? 0 : 0;

  const handleQuantityChange = (product: IRentalProduct, newQty: number): void => {
    if (newQty <= 0) {
      removeProduct(toNumber(product.id));
    } else if (products[product.id]) {
      changeProductQuantity(toNumber(product.id), newQty);
    } else {
      addProduct(product, newQty);
    }
  };

  const handleSuccess = (): void => {
    setShowRentInfo(false);
    setStep(2);
    scrollToRef();
  };

  return (
    <>
      <div className="box">
        <div className="box-content">
          <FilterRent />
          <ProductList />
        </div>
        {showRentInfo && (
          <BoxModal
            isPageAlert
            ref={rentInfoRef}
            title="Haben Sie an alles gedacht?"
            html={
              <div>
                <div>Passende Maschine ausgewählt?</div>
                <div>Passende Zugbacke zu Pressring / Presskette?</div>
                {(machineProduct || zugbackeProduct) && (
                  <div className="input-container">
                    {machineProduct && (
                      <div className="styled-input inline">
                        <label>{POPUP_PRODUCT_MACHINE}</label>
                        <InputNumber
                          value={machineQty}
                          min={0}
                          onChange={e => handleQuantityChange(machineProduct, Number(e.target.value))}
                        />
                      </div>
                    )}
                    {zugbackeProduct && (
                      <div className="styled-input inline">
                        <label>{POPUP_PRODUCT_ZUGBACKE}</label>
                        <InputNumber
                          value={zugbackeQty}
                          min={0}
                          onChange={e => handleQuantityChange(zugbackeProduct, Number(e.target.value))}
                        />
                      </div>
                    )}
                  </div>
                )}
              </div>
            }
            btnText="Weiter zum Versand"
            btnIcon="arrow-right"
            secondaryCtaButton="Weitere Produkte auswählen"
            closeFunction={() => {
              setShowRentInfo(false);
            }}
            successFunction={handleSuccess}
          />
        )}
      </div>
      {/*
      // find me in RentCart.tsx
      <div className="under-box">
        <div className="under-box-right">
          <Button
            disabled={!isValid}
            className={classNames('btn-xl btn-full', {
              'btn-disabled': !isValid
            })}
            // className="btn-l btn-full"
            onClick={() => nextStep()}
            hasRightIcon
          >
            Weiter zum Versand
          </Button>
        </div>
      </div>
      */}
    </>
  );
};

export default StepProductSelect;
